/* global axios */
import ApiClient from '../ApiClient';

// Customer Journey Flow (T-20): fluxo Sankey da jornada (entrada->bot->atendimento->pendência->desfecho).
class JourneyAPI extends ApiClient {
  constructor() {
    super('fandata/journey', { accountScoped: true });
  }

  // T-252: só canal. A Jornada é o caminho da IA até o humano; recortar por um dos dois
  // apagaria metade do caminho que a tela existe para mostrar.
  get({ since, until, entrada, parceiro, inboxId } = {}) {
    return axios.get(this.url, {
      params: { since, until, entrada, parceiro, inbox_id: inboxId },
    });
  }

  // Drill-down (Fase 3): conversas de um segmento/nó do fluxo.
  conversations({ node, since, until, entrada, parceiro, pagina, porPagina } = {}) {
    return axios.get(`${this.url}/conversations`, {
      params: { node, since, until, entrada, parceiro, pagina, por_pagina: porPagina },
    });
  }
}

export default new JourneyAPI();
